import React, { useEffect, useState } from 'react';
import { Alert, Modal, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import TwoFactorEnroll from './TwoFactorEnroll';
import { getProfile } from '../modules/auth/api';
import { setSession } from '../modules/auth/stores/slice';

/**
 * OVO-159 — voluntary enrollment from the header dropdown. Shows the current
 * status (enabled → info only; a reset goes through a super admin) or the
 * enrollment panel. On completion the fresh session (twoFactor claim) is
 * installed so the user keeps working without re-logging.
 */
const TwoFactorModal = ({ open, onClose }) => {
  const { t } = useTranslation('auth');
  const dispatch = useDispatch();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    setProfile(null);
    getProfile().then(({ response }) => {
      setProfile(response || {});
      setLoading(false);
    });
  }, [open]);

  return (
    <Modal
      title={t('twoFactorTitle', 'Two-factor authentication')}
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={440}
    >
      {loading && (
        <div style={{ textAlign: 'center', padding: 24 }}>
          <Spin />
        </div>
      )}
      {!loading && profile?.totpEnabled && (
        <Alert
          type="success"
          showIcon
          message={t('twoFactorEnabled', 'Two-factor authentication is enabled on your account.')}
          description={t(
            'twoFactorResetHint',
            'Lost your authenticator? Use a recovery code at login, or ask a super admin to reset your enrollment.',
          )}
        />
      )}
      {!loading && profile && !profile.totpEnabled && (
        <TwoFactorEnroll
          onDone={(enabled) => {
            dispatch(setSession(enabled));
            onClose && onClose();
          }}
        />
      )}
    </Modal>
  );
};

export default TwoFactorModal;
